const $ = require('jquery');
const get = require('lodash/get');
const modal = require('./modal');

module.exports = {
  init() {
    var op = globals;
    const setCookie = function (cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      const expires = `expires=${d.toUTCString()}`;
      const path = 'path=/';
      document.cookie = `${cname}=${cvalue}; ${expires};${path}`;
    };
    const getCookie = function (cname) {
      const name = `${cname}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return '';
    };

    $(document).on('change', 'select#settings-locale', () => {
      const old_locale = getCookie('opc[l]');
      const locale = $('select#settings-locale option:selected').val();
      setCookie('opc[l]', locale, 60);
      const settings_url = `${get(globals, 'webroot', '/')}${locale}/settings`;
      window.location = settings_url;
      $.get(`${get(globals, 'webroot', '/')}settings/set_locale/${locale}`);
      return 1;
    });

    const checkSettingsFormPasswords = function () {
      $("[name='password_check'], [name='password']").keyup((e) => {
        if (($("[name='password']").val() == $("[name='password_check']").val()) && $("[name='password']").val() != '' && $("[name='password_check']").val() != '') {
          $('.settingsForm-password').addClass('settingsForm-password--ok').removeClass('settingsForm-password--notok').removeClass('error');
        } else {
          $('.settingsForm-password').removeClass('settingsForm-password--ok').addClass('settingsForm-password--notok').addClass('error');
        }
      });
    };

    $(document).ready(() => {
      checkSettingsFormPasswords();
    });

    $(document).on('pjax:end', () => {
      checkSettingsFormPasswords();
    });

    $(document).on('click', '.clearSiteData', (e) => {
      e.preventDefault();

      //
      const confirmMessage = get(translations, 'txt: Vai vēlies dzēst {:hostname} saglabātos datus pārlūkā?', '')
        .replace('{:hostname}', window.location.hostname);
      //
      const additionalInfo = get(translations, 'txt: *Šī darbība veiks "Iziet" funkciju, pēc kuras Tev portālā būs atkārtoti jāielogojas.', '')
        .replace('{:hostname}', window.location.hostname);
      //
      const msg = `${confirmMessage}<div style="margin-top: 1em; font-size: 90%">${additionalInfo}</div>`;

      modal.confirm(msg, (response) => {
        if (response) {
          window.localStorage.clear();
          window.location.href = e.currentTarget.href;
        }
      });
    });
  },
};
